<form >
<vue-text-input
    label="{{ 'label.alerts' | translate | async }}"
    formControlName="getDatafromAlert"
    [required]="true"

  ></vue-text-input>
   <vue-select
    label="{{ 'title.queue' | translate | async }}"
    [required]="true"
  ></vue-select>
  <h1>Alert Condition</h1>
  <app-alert-condition></app-alert-condition>
 

  <!-- <h1>Utilization Evaluation</h1>
  <div style="display: flex; align-items: baseline;">
     <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1">Across full date range:</mat-radio-button>
        <mat-radio-button value="2">Per day:</mat-radio-button>
        <mat-radio-button value="3">Per time slot:</mat-radio-button>
        </mat-radio-group>

  </div> -->
  <div style="display: flex; margin-top: 32px; align-items: baseline;">
    <h1>Execution Time*:</h1>
    <vue-select class="depo"
    
    [required]="true"
  ></vue-select>
  </div>

  <div style="margin-top: 15px;">
    <span><b>Email*</b>:</span>
     <mat-form-field appearance="outline" style="width:290px; margin-left: 12px;">
        <input matInput type="text" placeholder="Email">
    </mat-form-field>
  </div>
</form>

